import { useState, useEffect } from 'react'

import { classNames } from '../../../lib/helpers'

export default function FilterBubbles(params) {
  const { 
    items=[], 
    selectedItem, 
    setSelectedItem,    
    filterTitle='', 
    chunk=1, // load chunk when pressing 'show more'
    chunkInitial=1, // initially visible number of items 
    itemAll = { name: 'All', slug: 'all', count: 0 }  // aditional item All
  } = params
  
  if (!items?.length) return <></>

  const [page, setPage] = useState(1)  // Using to load more items
  const totalCount = items?.map(item => item?.count)?.reduce((previous, current) => previous + current)  // if 'count' is not provided for itemAll then sum up.
  const itemsFull = [ { name: itemAll?.name, slug: itemAll?.slug, count: itemAll?.count || totalCount }, ...items]
  const currentChunk = page===1 ? chunkInitial : chunkInitial + (page - 1)*chunk
  const itemsVisible = itemsFull?.slice(0, currentChunk)  // without 'show more' bubble
  useEffect(() => setSelectedItem(itemsVisible[0]), []);  // to set 'all' bubble as initial one

  const showMoreStatus = page===1 ? itemsFull?.length > chunkInitial : itemsFull?.length > (chunkInitial + (page-1)*chunk) //page*chunk < items?.length
  const showMoreLeft = page===1 ? itemsFull?.length - chunkInitial : itemsFull?.length  - chunkInitial - (page-1)*chunk 

  return (    
    <div className="max-w-7xl mx-auto py-2 px-3 sm:flex">
      
      {filterTitle && (
        <div className="pl-2 pt-3 sm:flex sm:mr-4">
          <span className="my-0.5 text-xs font-semibold uppercase tracking-wide text-gray-500">
            {filterTitle}
          </span>

          <div aria-hidden="true" className="hidden w-px h-5 bg-gray-300 sm:block sm:ml-4" />
        </div>
      )}
      
      <div className="mt-2 sm:mt-0">
        <div className=" flex flex-wrap items-center">
          {itemsVisible?.map((item) => (
            <button
              onClick={() => { 
                setSelectedItem(item); 
                if (item?.slug === 'all') { setPage(1) }
              }}
              key={item?.slug}
              className={classNames(item?.slug === selectedItem?.slug ? 
                      'bg-crisp-100 text-crisp-800' : 
                      'bg-white text-gray-900', 
                      'm-1 inline-flex rounded-full border border-gray-200 items-center py-1.5 pl-3 pr-2 text-sm font-medium')}
            >
              <span>{item?.name}</span>
              <span 
                className={classNames(classNames(item?.slug === selectedItem?.slug ? 'bg-crisp-200 text-crisp-800' : 'bg-gray-100 text-gray-800', 'mx-1.5 inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-normal'))}
              >
                {item?.count}
              </span>
            </button>
          ))}

          {showMoreStatus && (
            <button onClick={() => setPage(page + 1)}
              className='m-1 bg-white hover:bg-crisp-200 text-gray-900 inline-flex rounded-full border border-gray-200 items-center py-1.5 pl-3 pr-2 text-sm font-medium'
            >
              <span>Show More ...</span>
              <span 
                className='bg-gray-100 text-gray-800 mx-1.5 inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-normal'                        
              >
                {showMoreLeft} left
              </span>                      
            </button>
          )}
        </div>
      </div>

    </div>   
  )
}